import { useDispatch, useSelector } from "react-redux";
import { selectSelectedCategoryUpdateId } from "../../features/it-user-forms/user-forms-slice";
import { useCallback, useEffect } from "react";
import { socketSetup } from "../../library/socket-io/socket-setup";
import { accountCategoryListAPI } from "../../api/it/account-category/account-category-api";

interface SocketPayload {
    categoryId: number;
}

export const useCategorySocket = () => {
    const dispatch = useDispatch();
    const currentCategoryId = useSelector(selectSelectedCategoryUpdateId);

    const invalidate = useCallback(
        ({ categoryId }: SocketPayload) => {
            dispatch(
                accountCategoryListAPI.util.invalidateTags([
                    { type: "AcctDepartment", id: "LIST" },
                    { type: "AcctLocation", id: "LIST" },
                    { type: "AcctRole", id: "LIST" },
                    { type: "AccountCategory", id: "LIST" },
                ])
            );
            // Ignore updates for other proposals
            if (categoryId !== currentCategoryId) return;

            dispatch(
                accountCategoryListAPI.util.invalidateTags([
                    { type: "AcctDepartment", id: categoryId },
                    { type: "AcctLocation", id: categoryId },
                    { type: "AcctRole", id: categoryId },
                    { type: "AccountCategory", id: categoryId },
                ])
            );
        },
        [dispatch, currentCategoryId]
    );

    useEffect(() => {
        if(!socketSetup) return
    
        socketSetup.on("createSystemLookup", invalidate)
        socketSetup.on("updateSystemLookup", invalidate)
    
        return () => {
            socketSetup.off("createSystemLookup", invalidate)
            socketSetup.off("updateSystemLookup", invalidate)
        }
    }, [invalidate])
}